'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Meal Planning
 * This gets shown when user clicks on the link
 * on App1 of Module2
 */
var MealPlanning = function (_Component) {
  (0, _inherits3.default)(MealPlanning, _Component);

  function MealPlanning() {
    (0, _classCallCheck3.default)(this, MealPlanning);
    return (0, _possibleConstructorReturn3.default)(this, (MealPlanning.__proto__ || (0, _getPrototypeOf2.default)(MealPlanning)).apply(this, arguments));
  }

  (0, _createClass3.default)(MealPlanning, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Meal planning is strategy that can ',
          _react2.default.createElement(
            'strong',
            { className: styles.orangeText },
            'make healthy eating a bit easier. '
          ),
          'Planning what you will eat for the whole week before you go shopping is a great way to make sure you will have',
          _react2.default.createElement(
            'strong',
            { className: styles.orangeText },
            ' enough healthy snacks and meals for your child to eat.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'By planning your meals you can:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Make sure you always have vegetables in the house which are washed, chopped up and ready to eat'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Save yourself time'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Save yourself money'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          { className: styles.greenText },
          _react2.default.createElement(
            'strong',
            null,
            'Consistently offering vegies'
          ),
          ' to children is one of the most important ways to encourage them to eat their vegies. Plan to offer at least one fruit or vegetable with each meal and snack.'
        )
      );
    }
  }]);
  return MealPlanning;
}(_react.Component);

exports.default = MealPlanning;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Components/MealPlanning.js
// module id = 1192
// module chunks = 0